import React from 'react';
import { DashboardLayout } from '../components/DashboardLayout';
import { AssetsLiabilitiesSection } from '../components/AssetsLiabilitiesSection';
import { CurrencyToggle } from '../components/CurrencyToggle';
import { useEntityStore, usePortfolioPrefsStore } from '../store';

// Entities-scope A&L: same component as Personal. A specific entity is scoped
// by entity_id; "All Entities" renders the aggregate (scope=entity, no
// entity_id), mirroring how "All Personal" renders scope=personal with none.

export function EntitiesAssetsLiabilitiesPage() {
  const selectedEntity = useEntityStore((s) => s.selectedEntity);
  const displayCurrency = usePortfolioPrefsStore((s) => s.displayCurrency);

  // "all" is the All Entities aggregate. Jurisdiction groups (group:*) are not
  // supported here; the user picks a specific entity or All Entities.
  const isAllEntities = selectedEntity === 'all';
  const isGroup = !!selectedEntity && selectedEntity.startsWith('group:');
  const unsupported = !selectedEntity || isGroup;

  return (
    <DashboardLayout>
      <div className="space-y-6 p-4 md:p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">
              Assets & Liabilities
            </h1>
            <p className="text-muted-foreground mt-1">
              {isAllEntities ? 'All Entities (aggregate)' : 'Entity scope'}
            </p>
          </div>
          <CurrencyToggle />
        </div>

        {unsupported ? (
          <div className="rounded-md border p-6 text-center text-sm text-muted-foreground">
            Select a specific entity or All Entities from the sidebar to view assets and liabilities.
          </div>
        ) : (
          <AssetsLiabilitiesSection
            scope="entity"
            entityId={isAllEntities ? undefined : selectedEntity}
            displayCurrency={displayCurrency}
          />
        )}
      </div>
    </DashboardLayout>
  );
}
